import { useUserManagementController } from "../UserManagement.controller.ts";
import MenuView from "../../../components/menu/Menu.view.tsx";
import React, { type CSSProperties } from "react";
import MenuEnum from "../../../components/menu/Menu.enum.ts";
import { getDesktopMenuWidth } from "../../../tools/ConfigurationReader.ts";
import styles from "./UserManagement.desktop.module.css";
import { useTranslation } from "react-i18next";
import { FaRegCirclePlay, FaRegCircleStop } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";
import UserDialogView from "../../../dialogs/user-dialog/UserDialog.view.tsx";
import UserMarketsDialogView from "../../../dialogs/user-markets-dialog/UserMarketsDialog.view.tsx";
import UserResetPasswordView from "../../../dialogs/user-reset-password/UserResetPassword.view.tsx";
import TableView from "../../../components/shared/table/Table.view.tsx";

export default function UserManagementDesktopView() {
  const { t } = useTranslation();
  const {
    deactivateSelected,
    activateSelected,
    addUser,
    onDialogCloseClick,
    onUserDialogCloseClick,
    gridRef,
    users,
    columnDefs,
    isUserDialogOpen,
    isUserMarketsDialogOpen,
    isUserResetPasswordDialogOpen,
    currentUser,
    loading,
  } = useUserManagementController();

  return (
    <div className={styles.main}>
      {isUserDialogOpen && (
        <UserDialogView
          user={currentUser}
          handleDialogCloseClick={onUserDialogCloseClick}
        />
      )}

      {isUserMarketsDialogOpen && (
        <UserMarketsDialogView
          user={currentUser}
          handleDialogCloseClick={onDialogCloseClick}
        />
      )}

      {isUserResetPasswordDialogOpen && (
        <UserResetPasswordView
          user={currentUser}
          handleDialogCloseClick={onDialogCloseClick}
        />
      )}

      <MenuView menu={MenuEnum.Administration} />
      <div
        className={styles.tableContainer}
        style={
          {
            "--menuWidth": getDesktopMenuWidth(),
          } as CSSProperties
        }
      >
        <div className={styles.iconContainer}>
          <FaPlus
            className={styles.icon}
            onClick={addUser}
            title={t("table.userManagement.addUser")}
          />
          <FaRegCircleStop
            className={styles.icon}
            onClick={deactivateSelected}
            title={t("table.userManagement.deactivateSelected")}
          />
          <FaRegCirclePlay
            className={styles.icon}
            onClick={activateSelected}
            title={t("table.userManagement.activateSelected")}
          />
        </div>
        <TableView
          gridRef={gridRef}
          data={users}
          columnDef={columnDefs}
          loading={loading}
        />
      </div>
    </div>
  );
}
